module.exports = "<div>\n  <div class=\"pull-left padding-10\">{{label}}</div>\n  <div class=\"btn2 pull-left margin-5 padding-5\" *ngFor=\"let o of options\" (click)=\"onSelect($event,o.id)\">{{o.name}}</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// /Users/eduar.doramirez/developer/code/edd/ceramicamx/web/cmx-catalog/src/app/stoggle/stoggle.component.html
// module id = ../../../../../src/app/stoggle/stoggle.component.html
// module chunks = main